import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import arthereumProvider from "../../../backend/ArthereumProvider";
import CommonPageTitle from "../../components/CommonPageTitle";
import IconDisplay from "../../components/IconDisplay";
import useThemeHook from "../../hooks/useThemeHook";
import { useTranslationHook } from "../../hooks/useTranslationHook";
import { actions } from "../../redux";
import { THEME_COLORS } from "../../themes/DarkLight";
import {
  LocalStorageController,
  LOCAL_STORAGE_DATA,
} from "../../utils/LocalStorageController";
import { useNavigate } from "react-router-dom";
import getUserSignInData from "../../utils/getUserSignInData";
import CommonNavBar from "../../components/CommonNavBar";

const EmailVerificationPage = ({}) => {
  const userData = useSelector((state) => (state as any).actualUser);
  const theme = useThemeHook();
  const getTranslationText = useTranslationHook();

  const [verificationCode, setVerificationCode] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const dispatch = useDispatch();

  const handleSendVerificationEmail = async () => {
    try {
      setLoading(true);
      setError("");
      await arthereumProvider.sendVerificationEmail();
      alert(getTranslationText("verification_email_sent"));
    } catch (error: any) {
      setError(error.message);
    } finally {
      setLoading(false);
    }
  };
  const navigate = useNavigate();

  const handleVerifyEmail = async () => {
    if (!verificationCode) {
      setError(getTranslationText("verification_code_required"));
      return;
    }

    try {
      setLoading(true);
      setError("");
      await arthereumProvider.verifyEmail(verificationCode);

      const user = await arthereumProvider.signIn(await getUserSignInData());
      dispatch(actions.setActualUser(user));
      alert(getTranslationText("email_verified_success"));
      setTimeout(() => {
        navigate(-1);
      }, 300);
    } catch (error: any) {
      setError(error.message);
    } finally {
      setLoading(false);
    }
  };

  if (userData.user.emailVerified) {
    return (
      <div
        style={{
          padding: "20px",
          backgroundColor: THEME_COLORS[theme].page_background_color,
        }}
      >
        <h2>{getTranslationText("email_already_verified")}</h2>
      </div>
    );
  }

  return (
    <div style={{ flex: 1 }}>
      <div
        onClick={() => {
          // Handle keyboard dismissal if needed
        }}
        style={{
          flex: 1,
          backgroundColor: THEME_COLORS[theme].page_background_color,
        }}
      >
        <CommonNavBar />

        <div
          style={{
            marginTop: "10px",
            flex: 1,
            backgroundColor: THEME_COLORS[theme].page_background_color,
          }}
        >
          <IconDisplay />
          <CommonPageTitle
            padding={0}
            title={getTranslationText("verify_email")}
          />

          {error && (
            <p
              style={{
                color: THEME_COLORS[theme].red,
                marginBottom: "10px",
              }}
            >
              {error}
            </p>
          )}

          {success && (
            <p
              style={{
                color: THEME_COLORS[theme].green,
                marginBottom: "10px",
              }}
            >
              {success}
            </p>
          )}

          <button
            style={{
              marginTop: "20px",
              backgroundColor: "blue",
              color: "white",
              padding: "10px",
              cursor: "pointer",
            }}
            onClick={handleSendVerificationEmail}
          >
            {getTranslationText("send_code")}
          </button>

          <input
            style={{
              marginTop: "20px",
              padding: "10px",
              backgroundColor: THEME_COLORS[theme].component_background_color,
            }}
            placeholder={getTranslationText("enter_verification_code")}
            value={verificationCode}
            onChange={(e) => setVerificationCode(e.target.value)}
            type="text"
            maxLength={5}
          />

          {verificationCode.length === 5 && (
            <button
              style={{
                marginTop: "20px",
                backgroundColor: "green",
                color: "white",
                padding: "10px",
                cursor: "pointer",
              }}
              onClick={handleVerifyEmail}
            >
              {getTranslationText("verify_email")}
            </button>
          )}

          {loading && (
            <div>
              Loading...
              {/* Replace with a spinner if needed */}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default EmailVerificationPage;
